import { BRAND_CLASSIFICATION } from 'domains/seller-product/constants'
import * as Yup from 'yup'

const consignmentInboundSchema = Yup.object().shape({
  classifications: Yup.array()
    .of(
      Yup.object().shape({
        quantity: Yup.number()
          .required('Required')
          .moreThan(0, 'Must be more than 0.'),
        tl_brand_classification: Yup.object().shape({
          name: Yup.string()
            .required('Required')
            .oneOf(
              [
                BRAND_CLASSIFICATION.HIGH_END_LUXURY,
                BRAND_CLASSIFICATION.ASPIRATIONAL_LUXURY,
                BRAND_CLASSIFICATION.LUXURY,
                BRAND_CLASSIFICATION.BRANDED
              ],
              'Klasifikasi harus merupakan luxury, hign end luxury, aspirational luxury, atau branded.'
            )
        })
      })
    )
})

export default consignmentInboundSchema
